import { Filter, Identifiable, Sort, Tag } from "@planzone/dto";
import { State } from "./types";

function areArrayEqual(first: string[], second: string[]): boolean {
  const set = new Set([...first, ...second]);

  return set.size === first.length && set.size === second.length;
}

function hasSameKeys(first: Filter, second: Filter): boolean {
  return areArrayEqual(Object.keys(first), Object.keys(second));
}

function extractId<I extends Object, K extends keyof I>(
  col: I[],
  keyName: K,
): I[K][] {
  return col.map((o) => o[keyName]);
}

function isTagList(key: string): boolean {
  return key === "projectsElementsTags" || key === "projectsTags";
}

function isView(key: string): boolean {
  return key === "view";
}

function areFiltersEqual(first: Filter, second: Filter): boolean {
  if (!hasSameKeys(first, second)) {
    return false;
  }

  return Object.entries(first).reduce((areEqual, [key, value]) => {
    if (!areEqual || !(key in second)) return false;
    const secondValue = second[key as keyof typeof second];
    if (!Array.isArray(value)) return value === secondValue;
    return isTagList(key)
      ? areArrayEqual(
          extractId(value as Tag[], "name"),
          extractId(secondValue as Tag[], "name"),
        )
      : areArrayEqual(
          extractId(value as Identifiable<any>[], "uuid"),
          extractId(secondValue as Identifiable<any>[], "uuid"),
        );
  }, true);
}

function matchRequest(
  state: State,
  filter: Filter,
  view: "simple" | "indicators" = "simple",
  sort: Sort,
  size: number,
): number {
  return state.findIndex(
    (req) =>
      req.sort === sort &&
      req.size === size &&
      areFiltersEqual(req.filter, filter) &&
      (req.view === view || (req.view === undefined && view === "simple")),
  );
}

export { matchRequest };
